import Vue from 'vue'

import moment from 'moment'
import 'moment/locale/es'

Vue.filter('moment_dia_de_mes_ano', function (date) {
	return moment(date).locale('es').format('LL')
});

Vue.filter('moment_dia_mes_abre', function (date) {
	return moment(date).locale('es').format('DD-MMM')
});

Vue.filter('moment_dia_mes_ano_hora_minuto', function (date) {
	return moment(date).locale('es').format('LLL')
});

Vue.filter('moment_ago', function (date) {
	return moment(date).fromNow()
});
